export default () => {
	const heroAnchor = document.querySelectorAll(".hero__anchor");

	if (!heroAnchor) return;

	heroAnchor.forEach(item => {
		item.addEventListener('click', function (e) {
			e.preventDefault();
			const parentSection = this.closest('section'),
				offsetSection = parentSection.offsetTop,
				sectionHeight = parentSection.offsetHeight,
				y = sectionHeight + offsetSection;
			window.scrollTo({top: y, behavior: 'smooth'});
		})
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/scroll-down.js